import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/checked.svg'
import _imports_1 from '@/assets/icons/arrow-customize-builder-back.svg'


const _hoisted_1 = {
  key: 0,
  class: "container-instructions"
}
const _hoisted_2 = { class: "content-builder-img" }
const _hoisted_3 = {
  key: 0,
  class: "container-instructions"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "logo-checked",
  src: _imports_0
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", null, "Click logo to select builder", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!$setup.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", null, "Click logo to select builder", -1)
          ]))]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.isDesktop ? $setup.visibleItems : $setup.props.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["img-builder-container", { 'img-checkmark': $setup.props.selectedItem?.logo === item.logo }]),
          key: item._id || item.logo,
          onClick: ($event: any) => ($setup.onSelectItem(item))
        }, [
          _createElementVNode("img", {
            class: "img-builder",
            src: item.logo
          }, null, 8, _hoisted_5),
          ($setup.props.selectedItem?.logo === item.logo && !$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true)
        ], 10, _hoisted_4))
      }), 128)),
      ($setup.showMoreButton && $setup.isDesktop)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "button-more",
            onClick: $setup.showMoreItems
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              class: "arrow-more",
              src: _imports_1
            }, null, -1),
            _createElementVNode("span", { class: "text-more" }, "More", -1)
          ]))]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}